import React from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { Chip, LinearProgress } from "@material-ui/core";
import cardholderDataColumn from "../../dataColumns/cardholderDataColumn";
import useCardholders from "../../hooks/modules/cardholder/useCardholders";
import useStyles from "../../hooks/useStyles";
import { Strings } from "../../assets/res/en";
import { SearchBar } from "../../components/searchBox/SearchBar";
import Unauthorized from "../../components/Unauthorized";

export default function Cardholders() {
  const classes = useStyles();
  const { columns, sytlingOptions } = cardholderDataColumn(classes);
  const {
    filters,
    searchData,
    getAllCardholders,
    searchOptions,
    tableRef,
    cardHolderPermission,
  } = useCardholders();

  return (
    <>
      {cardHolderPermission.read === true ? (
        <>
          <SearchBar options={searchOptions} />
          <MaterialTable
            title={Strings.COLUMN_CARD_TITLE}
            columns={columns}
            tableRef={tableRef}
            data={(query) => getAllCardholders(query)}
            options={sytlingOptions}
            components={{
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div
                    className={
                      filters.filter(
                        (item) =>
                          item.value && item.value.toString().trim() !== ""
                      ).length > 0
                        ? classes.filterContainer
                        : ""
                    }
                  >
                    {filters.filter(
                      (item) =>
                        item.value && item.value.toString().trim() !== ""
                    ).length > 0 &&
                      filters
                        .filter(
                          (item) =>
                            (item.value &&
                              item.value.toString().trim() !== "") ||
                            item.isClearAll === true
                        )
                        .map((fItem) =>
                          fItem.isClearAll === true ? (
                            <Chip
                              key={fItem.name}
                              color="secondary"
                              label="Reset All Filters"
                              onClick={() => fItem.clearAll(filters)}
                            />
                          ) : (
                            <Chip
                              key={fItem.name}
                              color="default"
                              label={fItem.value}
                              onDelete={() =>
                                fItem.remove(fItem, filters, searchData)
                              }
                            />
                          )
                        )}
                  </div>
                </div>
              ),
            }}
          />
        </>
      ) : cardHolderPermission.read === false ? (
        <Unauthorized />
      ) : (
        <LinearProgress />
      )}
    </>
  );
}
